const homeTutorDetailedRateCard = {
  key: "home-tutor",
  title: "Home Tutor Detailed Rate Card",
  note:
    "Indicative tutoring pricing. Final price depends on class level, subject difficulty, travel distance, and session frequency.",
  sections: [
    {
      title: "Per Session",
      items: [
        { name: "Primary level tutoring", price: "₹399 onwards per hour" },
        { name: "Secondary level tutoring", price: "₹499 onwards per hour" },
        { name: "Higher class / advanced subject tutoring", price: "₹699 onwards per hour" },
      ],
    },
    {
      title: "Monthly Plans",
      items: [
        { name: "Monthly home tutor plan", price: "₹2499 onwards" },
      ],
    },
    {
      title: "Consultation",
      items: [
        { name: "Tutor requirement consultation", price: "₹199" },
      ],
    },
  ],
};

export default homeTutorDetailedRateCard;